import {
  createBundledHighlighter,
  createSingletonShorthands,
  guessEmbeddedLanguages,
} from 'shiki/core'
import { createJavaScriptRegexEngine } from 'shiki/engine/javascript'

export * from 'shiki/core'
export { createJavaScriptRegexEngine } from 'shiki/engine/javascript'
export { createOnigurumaEngine, loadWasm } from 'shiki/engine/oniguruma'

/**
 * Shiki's own entry point in place of the one that carries every language it
 * knows. `@pierre/diffs` reaches for that entry to look a language up by name,
 * which asks the bundler for all ~250 grammars and ~60 themes as lazily loaded
 * chunks. F-plus is the only language this portal ever highlights, and it is
 * handed to the renderer directly by `registerFPlusDiffHighlighting`, so none
 * of them is ever loaded — they are only published.
 *
 * The registries are therefore empty here. A language or theme that is not
 * registered as a custom one now fails to resolve rather than being fetched,
 * which is the intent: there is exactly one of each, and it is ours.
 */
export const bundledLanguages = {}
export const bundledLanguagesAlias = {}
export const bundledLanguagesBase = {}
export const bundledLanguagesInfo = []
export const bundledThemes = {}
export const bundledThemesInfo = []

/**
 * The bundled entry builds this over the full registries and defaults to the
 * Oniguruma engine, pulling in its WebAssembly. Both are replaced: the
 * registries are empty, and the JavaScript engine is the one the diff renderer
 * asks for anyway.
 */
export const createHighlighter = createBundledHighlighter({
  langs: bundledLanguages,
  themes: bundledThemes,
  engine: () => createJavaScriptRegexEngine(),
})

export const {
  codeToHast,
  codeToHtml,
  codeToTokens,
  codeToTokensBase,
  codeToTokensWithThemes,
  getLastGrammarState,
  getSingletonHighlighter,
} = createSingletonShorthands(createHighlighter, { guessEmbeddedLanguages })
